export const environment = {
  production: false,
  baseUrl: 'https://lightspeed.leisuretrends.com/api/',
  lightspeedRedirectUri: 'https://lightspeed.leisuretrends.com',
  envName: 'production',
};
